var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.921,
    height: 20.921,
    viewBox: "1483.496 365.023 20.921 20.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1499.605 381.132a9.576 9.576 0 0 1-5.648 1.959c-6.657 0-10.46-7.608-10.46-7.608a17.545 17.545 0 0 1 4.81-5.648m3.653-1.731a8.673 8.673 0 0 1 1.997-.228c6.656 0 10.46 7.607 10.46 7.607a17.592 17.592 0 0 1-2.054 3.034m-6.39-1.018a2.853 2.853 0 1 1-4.032-4.032",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#b1b1b1",
    fill: "transparent",
    "data-name": "Path 11012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1483.496 365.023 20.921 20.92",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#b1b1b1",
    fill: "transparent",
    "data-name": "Path 11013"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.675afee9d0078fab2483bb98cba1af01.svg";
export { ForwardRef as ReactComponent };